import { brandCopy } from './brand'

/** Strings for the console frame: rail, band, notices, crash screen, toasts (S2, K2). */
export const shellCopy = {
  skipToMain: 'Skip to main content',
  menu: 'Menu',
  documentTitle: (page: string) =>
    page ? `${page} · ${brandCopy.name}` : brandCopy.name,
  connection: {
    reconnecting: 'Connection lost — reconnecting',
    degraded: 'Connection degraded',
  },
  rail: {
    label: 'Workspace navigation',
    live: 'live',
    account: (name: string) => `Account, ${name}`,
    switchWorkspace: (name: string) => `Switch workspace, ${name}`,
    workspaceFallback: 'Workspace',
    newWorkspace: 'New workspace…',
    workspaceSettings: 'Workspace settings',
    waiting: 'Waiting on you',
    waitingLabel: (count: number) =>
      `Waiting on you, ${count.toLocaleString()}`,
    topics: 'Topics',
    newTopic: 'New topic',
    agents: 'Agents',
    newAgent: 'New agent',
    people: 'People',
    invitePerson: 'Invite member',
    you: 'You',
    online: 'online',
    offline: 'offline',
    showMore: (count: number) => `Show ${count.toLocaleString()} more`,
    skills: 'Skills',
    newSkill: 'New skill',
    recipes: 'Recipes',
    resources: 'Resources',
    newResource: 'Add resource',
  },
  account: {
    settings: 'Settings',
    billing: 'Billing',
    admin: 'Admin',
    signOut: 'Sign out',
  },
  appearance: {
    title: 'Appearance',
    open: 'Open appearance settings',
    useLight: 'Use light theme',
    useDark: 'Use dark theme',
    colour: 'Colour',
    textSize: 'Text size',
    textSample: 'Aa',
  },
  palettes: { iris: 'Iris', indigo: 'Indigo', violet: 'Violet' },
  contrast: { title: 'Contrast', standard: 'Standard', more: 'More' },
  band: { workspaceFallback: 'workspace', topicSettings: 'Topic settings' },
  error: {
    title: 'Could not show this page',
    stackCaption: 'component stack',
    retry: 'Retry',
  },
} as const
